import ct from 'countries-and-timezones'

import {Moreoptions, PointExpiry, PurchaseTypes, PassVariables} from '../enums/enums';
import {Campaign, CountryCode, Currencies, enums, PassDesign} from '../enums';
import { utils } from '.';


const getContryCodes = () => {
    CountryCode.sort((a, b) => {
        if(a.code < b.code) return -1;
        if(a.code > b.code) return 1;
        return 0;
    })
    return (
        <>
            <option value="">None</option>
            {CountryCode.map((value)=>(
                <option value={value.dial_code}>{value.code + value.dial_code + ' ' + value.flag}</option>
            ))}
        </>
    )
}

const getCurrencyCodes = () => {
    return(
        <>
            <option value="">None</option>
            {Currencies.map((value)=>(
                <option value={value.code}>{value.code + ' (' + value.symbol+')'}</option>
            ))}
        </>
    )
}


const getMonths = () => {


    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"]

    return(
        <>
            <option value="">None</option>
            {months.map((value)=>(
                <option value={value}>{value}</option>
            ))}
        </>
    )
}

const getGender = () => {


    const gender = [
        'male',
        'female'
    ]

    return(
        <>
            <option value="">None</option>
            {gender.map((value)=>(
                <option value={value}>{utils.capitalize(value)}</option>
            ))}
        </>
    )
}

const getTimezones = () => {
    return(
        <>
            <option value="">None</option>
            {Object.values(ct.getAllTimezones()).map((value)=>(
                <option value={value.name}>{value.name + ' ' + value.country + ' ' + value.utcOffsetStr}</option>
            ))}
        </>
    )
}

const getProgramActiveStatus = () => {
    const Programstatus = [
        {
            status : 'Active',
            value  : true
        },
        {
            status : 'Inactive',
            value  : false
        }
    ]

    return(
        <>
            {Programstatus.map((value)=>(
                <option value={value.value}>{value.status}</option>
            ))}
        </>
    )
}

const getMoreOptions = () => {
    return(
        <>
        {Moreoptions.map((value)=>(
            <option value={value.value}>{value.name}</option>
        ))}
    </>
    )
}

const getProgramApprovaltypes = () => {
    const Approvaltypes = [
        {
            name  : 'None',
            value : ''
        },
        {
            name    : 'Immediatley',
            value   : Campaign.ApprovalTypes.IMMEDIATELY
        },
        {
            name    : 'Manually',
            value   : Campaign.ApprovalTypes.MANUALLY
        },
        {
            name    : 'After a fixed duration',
            value   : Campaign.ApprovalTypes.AFTER_DURATION
        }
    
    ]
    return(
        <>
            {Approvaltypes.map((approvalType)=>(
                <option disabled={approvalType.value === Campaign.ApprovalTypes.MANUALLY} value={approvalType.value}>{approvalType.name}</option>
            ))}
        </>
    )
}

const getOperands = () => {
    const Operands = [
        {
            name  : 'None',
            value : ''
        },
        {
            name  : 'Greater Than',
            value : enums.Operands.GREATER
        },
        {
            name  : 'Lesser Than',
            value : enums.Operands.LESSER
        },
        {
            name  : 'Equals To',
            value : enums.Operands.EQUAL
        },
        {
            name  : 'Not Equals To',
            value : enums.Operands.NOT_EQUAL
        }
    ]

    return(
        <>
            {Operands.map((value)=>(
                <option value={value.value}>{value.name}</option>
            ))}
        </> 
    )
}

const getRuleSelectType = () => {
    const RuleSelectType = [
        {
            name  : 'None',
            value : ''
        },
        {
            name : 'Match Any',
            value: 'any'
        },
        {
            name : 'Match All',
            value: 'all'
        }
    ]

    return(
        <>
            {RuleSelectType.map((value)=>(
                <option value={value.value}>{value.name}</option>
            ))}
        </>
    )
}

const getPointExpiry = () => {
    return (
        <>
            {PointExpiry.map((value)=>(
                <option value={value.value}>{value.name}</option>
            ))}

        </>
    )
}

const getPurchasesTypes = () => {
    return (
        <>
            {PurchaseTypes.map((value)=>(
                <option value={value.value}>{value.name}</option>
            ))}

        </>
    )
}

const getPassVariables = () => {
    return (
        <>
            {PassVariables.map((value)=>(
                <option value={value.value}>{value.name}</option>
            ))}

        </>
    )
}

const PassTypes = () => {
        
    const passTypes = [
        {
            name  : 'None',
            value : ''
        },
        {
            name  : 'Coupon',
            value : PassDesign.PassTypes.COUPON
        },
        {
            name  : 'Ticket',
            value : PassDesign.PassTypes.TICKET
        },
        {
            name  : 'Loyalty Card',
            value : PassDesign.PassTypes.LOYALTY_CARD
        },
        {
            name  : 'Stamp Card',
            value : PassDesign.PassTypes.STAMP_CARD
        },
        {
            name  : 'Membership Card',
            value : PassDesign.PassTypes.MEMBERSHIP_CARD
        }
    ]

    return(
        <>
            {passTypes.map((type, idx)=>(
                <option key={idx} value={type.value}>{type.name}</option>
            ))}
        </>
    )
}

const appleCodesFormat = () => {
    const formats = [
        {
            name  : 'None',
            value : ''
        },
        {
            name  : 'QR Code',
            value : 'PKBarcodeFormatQR'
        },
        {
            name     : 'Barcode PDF417',
            value    : 'PKBarcodeFormatPDF417',
            disabled : true
        }
    ]

    return(
        <>
            {formats.map((type, idx)=> <option disabled={type.disabled} key={idx} value={type.value}>{type.name}</option>)}
        </>
    )
}

var country_list = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia","St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia","Turkey","Turkmenistan","Turks &amp; Caicos","Uganda","Ukraine","United Arab Emirates","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

export {
    getContryCodes,
    getCurrencyCodes,
    getTimezones,
    getProgramActiveStatus,
    getMoreOptions,
    getProgramApprovaltypes,
    getOperands,
    getRuleSelectType,
    getPointExpiry,
    getPurchasesTypes,
    getPassVariables,
    PassTypes,
    getGender,
    getMonths,
    appleCodesFormat,
}
